/*
 * Live-mode page navigation. Two glass chevron buttons pinned to the
 * left + right edges, vertically centered. Mirrors the bottom MmPageNav
 * but for one-handed flipping through pages, and the same enabled-pages
 * sequence is bound to the ArrowLeft/ArrowRight keyboard shortcuts.
 *
 * Search is intentionally excluded — it's only entered via the
 * magnifier button on the bottom strip.
 */

.button {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 56px;
  height: 88px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  z-index: 4;
  background: rgba(255, 255, 255, 0.32);
  border: 1px solid rgba(255, 255, 255, 0.42);
  color: var(--token-text-primary);
  backdrop-filter: blur(18px) saturate(160%);
  -webkit-backdrop-filter: blur(18px) saturate(160%);
  box-shadow: 0 12px 24px -10px rgba(8, 18, 12, 0.45);
  cursor: pointer;
  transition:
    background 120ms ease,
    transform 120ms ease,
    opacity 120ms ease;
}

.button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.55);
}

.button:disabled {
  opacity: 0.25;
  cursor: not-allowed;
}

/* Docked flush to the screen edges — outer corners are flat against
 * the edge, inner corners are rounded so each button reads as a tab
 * jutting in from the side. Frees the 12px gutter we used to leave. */
.prev {
  left: 0;
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 28px;
  border-bottom-right-radius: 28px;
}

.next {
  right: 0;
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 28px;
  border-bottom-left-radius: 28px;
}

.icon {
  width: 24px;
  height: 24px;
  pointer-events: none;
}
